import { render } from "./Commandes.vue?vue&type=template&id=1541eee0"
import script from "./Commandes.vue?vue&type=script&lang=js"
export * from "./Commandes.vue?vue&type=script&lang=js"

import exportComponent from "/data/www/cavilam/boutique/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__